<router-outlet></router-outlet>

<footer class="tw-text-center tw-my-12">
  <environment-selector></environment-selector>

  <div bitTypography="body2">Fallen Vault</div>
  <div bitTypography="body2">{{ version }}</div>
  <br />
  <div bitTypography="helper" id="vw-disclaimer">
    An independent interface for self-hosted vault servers.<br />
    Encryption and session handling remain provided by the existing client and server.
  </div>
</footer>
